class FunctionUtils {
  async asyncForEach<T>(
    array: T[],
    callback: (item: T, index: number, array: T[]) => Promise<void>
  ): Promise<void> {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  }

  async executeAsyncWhen<T>(
    callback: () => Promise<T>,
    condition: { when: boolean; fallback: T }
  ): Promise<T>;

  async executeAsyncWhen<T>(
    callback: () => Promise<T>,
    condition: { when: boolean; fallback?: never }
  ): Promise<T | null>;

  /**
   * Executes an asynchronous callback if a specified condition is met.
   */
  async executeAsyncWhen<T>(
    callback: () => Promise<T>,
    condition: { when: boolean; fallback?: T }
  ): Promise<T | null> {
    if (condition.when) {
      return callback();
    }
    return condition.fallback ?? null;
  }
}

const functionUtils = new FunctionUtils();
export default functionUtils;
